<template>
    <div class="card mc-output-frame e2e-output-frame"> 
        <a :class="scrollMarkClass" />
        <div v-if="outputFrame.title" 
             class="card-header" 
             style="padding: 5px 5px 5px 10px;">
            {{outputFrame.title}}
        </div> 
        <div class="card-body" style="padding: 15px;">
            <div v-for="fragment in outputFrame.fragments" 
                :key="fragment._key"
                :fragment="fragment"
                :is="resolveFragmentComponentName(fragment)">
            </div>
        </div> 
    </div>
</template>

<script>
import { resolveFragmentComponentName } from "./output-fragment-resolver";

import {
  scrollToLastScrollMark,
  SCROLL_MARK_CLASS,
  renderFormula
} from "../layout-bom";

export default {
  props: ["outputFrame"],
  data() {
    return {
      scrollMarkClass: SCROLL_MARK_CLASS
    };
  },
  methods: {
    resolveFragmentComponentName
  },
  mounted() {
    const that = this;
    this.$nextTick(() => {
      renderFormula(that.$el);
      scrollToLastScrollMark(that.$el);
    });
  }
};
</script>
 

<style scoped>
.mc-output-frame {
  margin: 10px 10px 10px 10px;
  margin-top: 10px;
}
</style>